
import React, { useState, useEffect,useRef } from "react";
import {
  Box, Card, Typography, Button, TextField, Checkbox, IconButton,
  CircularProgress, Chip, Grid, InputAdornment, Divider, Paper,
  Container, Tabs, Tab, Dialog, DialogTitle, DialogContent,
  DialogActions, TablePagination, Stack, Fade
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomDialog from "../../CustomDialog";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { apiRequest } from '../../fetchSetup';
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import  bg from "../Logos/med_icon3.png"


const AdminPendingUsers = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [actionDialog, setActionDialog] = useState({
    open: false,
    type: "",
    userIds: [],
    userNames: [],
    reason: ""
  });
  
  const [notificationDialog, setNotificationDialog] = useState({
    open: false,
    message: "",
    title: "",
    type: "info"
  });
  const [newUserNotifCount, setNewUserNotifCount] = useState(0);
  const [newUserNotifs, setNewUserNotifs]         = useState([]);
  const [notifAnchor, setNotifAnchor]             = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    userIds: [],
    userNames: [],
  });



  const token = sessionStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_PENDING_REGISTRATIONS_URL?.replace('/pending-registrations', '') || '';
  const AUTH_BASE_URL = process.env.REACT_APP_API_URL;
// ── Notification polling ──────────────────────────────────────

const notifFetchedRef = useRef(false);
const notifPollRef    = useRef(null);

useEffect(() => {
  if (notifFetchedRef.current) return;
  notifFetchedRef.current = true;

  fetchNotifCount(); // fetch once immediately

  const schedulePoll = () => {
    notifPollRef.current = setTimeout(async () => {
      await fetchNotifCount();
      schedulePoll();
    }, 30000);
  };
  schedulePoll();

  return () => clearTimeout(notifPollRef.current);
}, []);

const fetchNotifCount = async () => {
  try {
    const res = await apiRequest(`${AUTH_BASE_URL}/admin/new-user-notifications`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (data.success) {
      setNewUserNotifCount(data.unread_count);
      setNewUserNotifs(data.notifications || []);
    }
  } catch (err) {
    console.error("Failed to fetch notifications", err);
  }
};
const handleDeleteClick = (userId = null, userName = null) => {
    const isBulk = !userId && selectedUsers.length > 0;

    if (isBulk) {
      const userNames = (activeTab === 0 ? pendingUsers : allUsers)
        .filter((u) => selectedUsers.includes(u.user_id))
        .map((u) => u.name);
      setDeleteDialog({ open: true, userIds: selectedUsers, userNames });
    } else if (userId) {
      setDeleteDialog({ open: true, userIds: [userId], userNames: [userName] });
    }
  };

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const { userIds } = deleteDialog;
      let deletedCount = 0;

      if (userIds.length === 1) {
        // Single delete
        const res = await apiRequest(`${AUTH_BASE_URL}/delete-user/${userIds[0]}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.success) deletedCount = 1;
      } else {
        // Bulk delete
        const res = await apiRequest(`${AUTH_BASE_URL}/delete-users/bulk`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_ids: userIds }),
        });
        const data = await res.json();
        deletedCount = data.deleted_count || 0;
      }

      setDeleteDialog({ open: false, userIds: [], userNames: [] });
      setSelectedUsers([]);

      if (activeTab === 0) fetchPendingUsers();
      else fetchAllUsers();

      showNotification(
        `${deletedCount} user(s) permanently deleted`,
        "Deleted",
        "success"
      );
    } catch (err) {
      console.error(err);
      showNotification("Delete failed. Please try again.", "Error", "error");
    } finally {
      setLoading(false);
    }
  };


const markNotifsRead = async () => {
  try {
    await apiRequest(`${AUTH_BASE_URL}/admin/new-user-notifications/mark-read`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    setNewUserNotifCount(0);
  } catch (err) {}
};
  // ============= FETCH DATA =============
  


  const lastFetchedTabRef    = useRef(-1);
const pendingFetchedRef    = useRef(false);
const allUsersFetchedRef   = useRef(false);

useEffect(() => {
  // Don't refetch if tab hasn't actually changed
  if (activeTab === lastFetchedTabRef.current) return;
  lastFetchedTabRef.current = activeTab;

  if (activeTab === 0) {
    // Only fetch pending if not already fetched
    if (!pendingFetchedRef.current) {
      pendingFetchedRef.current = true;
      fetchPendingUsers();
    }
  } else {
    // Only fetch all users if not already fetched
    if (!allUsersFetchedRef.current) {
      allUsersFetchedRef.current = true;
      fetchAllUsers();
    }
  }
}, [activeTab]);

  useEffect(() => {
    filterUsers();
    setPage(0); // Reset to first page when search changes
  }, [searchQuery, pendingUsers, allUsers, activeTab]);

  const fetchPendingUsers = async () => {
    setLoading(true);
    try {
      const res = await apiRequest(`${process.env.REACT_APP_PENDING_REGISTRATIONS_URL}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setPendingUsers(data.users || []);
    } catch (error) {
      showNotification("Failed to fetch pending users", "Error", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const res = await apiRequest(`${BASE_URL}/users?status=all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setAllUsers(data.users || []);
    } catch (error) {
      showNotification("Failed to fetch all users", "Error", "error");
    } finally {
      setLoading(false);
    }
  };

  const filterUsers = () => {
    const sourceUsers = activeTab === 0 ? pendingUsers : allUsers;
    if (!searchQuery.trim()) {
      setFilteredUsers(sourceUsers);
      return;
    }
    const query = searchQuery.toLowerCase();
    const filtered = sourceUsers.filter(
      (user) =>
        user.name?.toLowerCase().includes(query) ||
        user.phone?.includes(query) ||
        user.email?.toLowerCase().includes(query) ||
        user.user_id?.toLowerCase().includes(query)
    );
    setFilteredUsers(filtered);
  };

  // ============= PAGINATION HANDLERS =============

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelectedUsers([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSelectedUsers([]);
  };

  // Get current page users
  const paginatedUsers = filteredUsers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // ============= USER ACTIONS =============

  const performAction = async (endpoint, userIds, reason = null) => {
    const isBulk = userIds.length > 1;
    let successCount = 0;

    if (isBulk) {
      try {
        const res = await apiRequest(`${process.env.REACT_APP_BULK_ACTION_URL}`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_ids: userIds,
            action: endpoint.replace('-user', ''),
            reason: reason || ""
          }),
        });
        const data = await res.json();
        if (res.ok) successCount = data.results.success.length;
      } catch (error) {
        console.error("Bulk action failed:", error);
      }
    } else {
      for (const userId of userIds) {
        try {
          const res = await apiRequest(`${BASE_URL}/${endpoint}/${userId}`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: reason ? JSON.stringify({ reason }) : undefined,
          });
          if (res.ok) successCount++;
        } catch (error) {
          console.error(`Failed to ${endpoint} user ${userId}:`, error);
        }
      }
    }

    return successCount;
  };

  const handleActionClick = (type, userId = null, userName = null) => {
    const isBulkAction = !userId && selectedUsers.length > 0;
    
    if (isBulkAction) {
      const userNames = (activeTab === 0 ? pendingUsers : allUsers)
        .filter((u) => selectedUsers.includes(u.user_id))
        .map((u) => u.name);
      
      setActionDialog({
        open: true,
        type,
        userIds: selectedUsers,
        userNames,
        reason: ""
      });
    } else if (userId) {
      setActionDialog({
        open: true,
        type,
        userIds: [userId],
        userNames: [userName],
        reason: ""
      });
    }
  };

  const confirmAction = async () => {
    setLoading(true);
    try {
      const { type, userIds, reason } = actionDialog;
  
      const requiresReason = ["reject", "block"].includes(type);
      if (requiresReason && (!reason || reason.trim().length < 5)) {
        showNotification("Please provide a reason (minimum 5 characters)", "Warning", "warning");
        setLoading(false);
        return;
      }
  
      const endpoint = `${type}-user`;
      const successCount = await performAction(endpoint, userIds, reason);
  
      setActionDialog({ open: false, type: "", userIds: [], userNames: [], reason: "" });
      setSelectedUsers([]);
  
      if (activeTab === 0) fetchPendingUsers();
      else fetchAllUsers();
  
      const actionPastTense = {
        approve: "approved",
        reject: "rejected",
        block: "blocked",
        unblock: "unblocked"
      }[type];
  
      showNotification(
        `${successCount} user(s) ${actionPastTense} successfully`,
        "Success",
        "success"
      );
    } catch (err) {
      console.error(err);
      showNotification("Action failed. Please try again.", "Error", "error");
    } finally {
      setLoading(false);
    }
  };
  
  // ============= UI HANDLERS =============

  const handleSelectAll = () => {
    if (selectedUsers.length === paginatedUsers.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(paginatedUsers.map((u) => u.user_id));
    }
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setViewDetailsOpen(true);
  };
  const handleRefresh = () => {
    setSearchQuery("");
    setSelectedUsers([]);
    setPage(0);
    // Reset refs so fetch actually runs
    if (activeTab === 0) {
      pendingFetchedRef.current = false;
      lastFetchedTabRef.current = -1;
      fetchPendingUsers();
      pendingFetchedRef.current = true;
    } else {
      allUsersFetchedRef.current = false;
      lastFetchedTabRef.current = -1;
      fetchAllUsers();
      allUsersFetchedRef.current = true;
    }
  };
  // const handleRefresh = () => {
  //   setSearchQuery("");
  //   setSelectedUsers([]);
  //   setPage(0);
  //   if (activeTab === 0) fetchPendingUsers();
  //   else fetchAllUsers();
  // };

  const showNotification = (message, title, type) => {
    setNotificationDialog({ open: true, message, title, type });
  };

  // ============= UTILITY FUNCTIONS =============

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getStatusChip = (user) => {
    const status = user.approval_status || "pending";
    const colors = {
      pending: { bg: "#FFF3E0", color: "#E65100" },
      approved: { bg: "#E8F5E9", color: "#2E7D32" },
      rejected: { bg: "#FFEBEE", color: "#C62828" },
      blocked: { bg: "#F3E5F5", color: "#6A1B9A" },
    };

    return (
      <Chip
        label={status.charAt(0).toUpperCase() + status.slice(1)}
        size="small"
        sx={{
          backgroundColor: colors[status]?.bg || "#E0E0E0",
          color: colors[status]?.color || "#424242",
          fontWeight: 600,
          fontSize: "12px",
          height: "24px",
          pointerEvents: "none"
        }}
      />
    );
  };

  const getActionButtons = (user) => {
    const status = user.approval_status;
    
    if (activeTab === 0) {
      return (
        <>
          <IconButton
            size="small"
            onClick={() => handleActionClick("approve", user.user_id, user.name)}
            sx={{
              backgroundColor: "#2E7D32",
              color: "white",
              "&:hover": { backgroundColor: "#1B5E20" },
              width: 32,
              height: 32,
            }}
            title="Approve User"
          >
            <CheckCircleIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => handleActionClick("reject", user.user_id, user.name)}
            sx={{ 
              border: "1px solid #E0E0E0", 
              width: 32, 
              height: 32,
              color: "#C62828",
              "&:hover": { backgroundColor: "#FFEBEE" }
            }}
            title="Reject User"
          >
            <CancelIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </>
      );
    } else {
      return (
        <>
          {status === "approved" && (
            <IconButton
              size="small"
              onClick={() => handleActionClick("reject", user.user_id, user.name)}
              sx={{ 
                border: "1px solid #C62828", 
                color: "#C62828", 
                width: 32, 
                height: 32,
                "&:hover": { backgroundColor: "#FFEBEE" }
              }}
              title="Reject User"
            >
              <CancelIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}
          {status === "rejected" && (
            <IconButton
              size="small"
              onClick={() => handleActionClick("approve", user.user_id, user.name)}
              sx={{
                backgroundColor: "#2E7D32",
                color: "white",
                "&:hover": { backgroundColor: "#1B5E20" },
                width: 32,
                height: 32,
              }}
              title="Approve User"
            >
              <CheckCircleIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}
          {status === "blocked" ? (
            <IconButton
              size="small"
              onClick={() => handleActionClick("unblock", user.user_id, user.name)}
              sx={{
                border: "1px solid #2E7D32",
                color: "#2E7D32",
                width: 32,
                height: 32,
                "&:hover": { backgroundColor: "#E8F5E9" }
              }}
              title="Unblock User"
            >
              <LockOpenIcon sx={{ fontSize: 18 }} />
            </IconButton>
          ) : (
            <IconButton
              size="small"
              onClick={() => handleActionClick("block", user.user_id, user.name)}
              sx={{
                border: "1px solid #6A1B9A",
                color: "#6A1B9A",
                width: 32,
                height: 32,
                "&:hover": { backgroundColor: "#F3E5F5" }
              }}
              title="Block User"
            >
              <BlockIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}
        </>
      );
    }
  };

  const getDialogConfig = () => {
    const { type, userNames } = actionDialog;
    const configs = {
      approve: {
        title: "Approve User(s)",
        message: `Are you sure you want to approve ${userNames.length} user(s)?`,
        requiresReason: false,
        color: "success"
      },
      reject: {
        title: "Reject User Registration",
        message: `You are about to reject ${userNames.length} user(s). Please provide a reason:`,
        requiresReason: true,
        color: "error"
      },
      block: {
        title: "Block User(s)",
        message: `You are about to block ${userNames.length} user(s). Please provide a reason:`,
        requiresReason: true,
        color: "error"
      },
      unblock: {
        title: "Unblock User",
        message: `Are you sure you want to unblock ${userNames[0]}?`,
        requiresReason: false,
        color: "success"
      }
    };
    return configs[type] || configs.approve;
  };

  const dialogConfig = getDialogConfig();

  return (

    <Box sx={{ maxWidth: 1400, mx: "auto",marginLeft: {
      xs: 0,
      md: "300px",
    }}}>
      <Container 
        maxWidth="xl" 
        sx={{ 
         pt: 1,
          px: { xs: 2, sm: 3, md: 4 }
        }}
      >
        {/* Header */}
        <Paper 
          elevation={0}
          sx={{ 
            p: 3,
            mb: 3,
            borderRadius: 3,
           backgroundImage: `
                     linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
                     url(${bg})
                   `,
                   backgroundSize: "cover",
                   backgroundPosition: "center",
                   backgroundRepeat: "no-repeat" ,
            color: "white"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <IconButton 
              onClick={() => navigate(-1)}
              sx={{
                color: "white",
                bgcolor: "rgba(255,255,255,0.1)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.2)" }
              }}
            >
              <ArrowBack />
            </IconButton>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                User Management
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Manage Resident Registrations & Accounts
              </Typography>
            </Box>
            {/* <IconButton
              onClick={handleRefresh}
              disabled={loading}
              sx={{
                color: "white",
                bgcolor: "rgba(255,255,255,0.1)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.2)" }
              }}
            >
              <RefreshIcon />
            </IconButton> */}
            <Box sx={{ display: "flex", gap: 1 }}>
              {/*  Bell */}
              <IconButton
                onClick={(e) => { setNotifAnchor(e.currentTarget); markNotifsRead(); }}
                sx={{ color:"white", bgcolor:"rgba(255,255,255,0.1)", "&:hover":{ bgcolor:"rgba(255,255,255,0.2)" } }}
              >
                <Badge badgeContent={newUserNotifCount} color="error" max={99}>
                  <NotificationsIcon />
                </Badge>
              </IconButton>

              {/* Dropdown */}
              <Menu
                anchorEl={notifAnchor}
                open={Boolean(notifAnchor)}
                onClose={() => setNotifAnchor(null)}
                PaperProps={{ sx: { width:340, maxHeight:420, borderRadius:2, mt:1 } }}
              >
                <Box sx={{ px:2, py:1.5, borderBottom:"1px solid #eee", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <Typography variant="subtitle2" fontWeight={700}>New Registrations</Typography>
                  {newUserNotifs.length > 0 && (
                    <Chip label={`${newUserNotifs.length} new`} size="small"
                      sx={{ bgcolor:"#FFF3E0", color:"#E65100", fontWeight:700, fontSize:"11px" }} />
                  )}
                </Box>

                {newUserNotifs.length === 0 ? (
                  <Box sx={{ py:4, textAlign:"center" }}>
                    <Typography variant="body2" color="text.secondary">No new registrations</Typography>
                  </Box>
                ) : (
                  newUserNotifs.slice(0, 8).map((notif, i) => (
                    <MenuItem key={i}
                      onClick={() => { setNotifAnchor(null); setActiveTab(0); fetchPendingUsers(); }}
                      sx={{ py:1.5, borderBottom:"1px solid #f5f5f5", alignItems:"flex-start", gap:1.5 }}>
                      {/* Avatar */}
                      <Box sx={{
                        width:36, height:36, borderRadius:"50%", flexShrink:0,
                        bgcolor: notif.read ? "#E0E0E0" : "#006D77",
                        display:"flex", alignItems:"center", justifyContent:"center",
                        color:"white", fontWeight:700, fontSize:14
                      }}>
                        {notif.name?.[0]?.toUpperCase() || "U"}
                      </Box>
                      <Box sx={{ flex:1, minWidth:0 }}>
                        <Typography variant="body2" fontWeight={600} noWrap>{notif.name}</Typography>
                        <Typography variant="caption" color="text.secondary" display="block" noWrap>{notif.phone} · {notif.email}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(notif.registered_at).toLocaleString("en-IN", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" })}
                        </Typography>
                      </Box>
                      {!notif.read && (
                        <Box sx={{ width:8, height:8, borderRadius:"50%", bgcolor:"#E65100", flexShrink:0, mt:0.5 }} />
                      )}
                    </MenuItem>
                  ))
                )}

                <Box sx={{ px:2, py:1, borderTop:"1px solid #eee", textAlign:"center" }}>
                  <Button size="small"
                    onClick={() => { setNotifAnchor(null); setActiveTab(0); fetchPendingUsers(); }}
                    sx={{ textTransform:"none", color:"#006D77", fontSize:"12px", fontWeight:600 }}>
                    View All Pending Approvals →
                  </Button>
                </Box>
              </Menu>

              {/* Refresh */}
              <IconButton onClick={handleRefresh} disabled={loading}
                sx={{ color:"white", bgcolor:"rgba(255,255,255,0.1)", "&:hover":{ bgcolor:"rgba(255,255,255,0.2)" } }}>
                <RefreshIcon />
              </IconButton>
            </Box>
          </Box>
        </Paper>

        {/* Tabs */}
        <Paper elevation={0} sx={{ mb: 3, borderRadius: 3 }}>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => {
              setActiveTab(newValue);
              setPage(0);
              setSelectedUsers([]);
              setSearchQuery("");
            }}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              px: 2,
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                minHeight: 60,
                color: "#666",
                "&.Mui-selected": {
                  color: "#006D77"
                }
              }
            }}
            TabIndicatorProps={{
              sx: { 
                height: 3,
                borderRadius: "3px 3px 0 0",
                backgroundColor: "#006D77"
              }
            }}
          >
            <Tab 
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <span>Pending Approvals</span>
                  {pendingUsers.length > 0 && (
                    <Chip 
                      label={pendingUsers.length} 
                      size="small" 
                      sx={{ 
                        height: 20,
                        fontSize: "11px",
                        bgcolor: "#FFF3E0",
                        color: "#E65100",
                        fontWeight: 700
                      }} 
                    />
                  )}
                </Box>
              }
            />
            <Tab 
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <span>All Users</span>
                  {allUsers.length > 0 && (
                    <Chip 
                      label={allUsers.length} 
                      size="small" 
                      sx={{ 
                        height: 20,
                        fontSize: "11px",
                        bgcolor: "#E8F5E9",
                        color: "#2E7D32",
                        fontWeight: 700
                      }} 
                    />
                  )}
                </Box>
              }
            />
          </Tabs>
        </Paper>

        {/* Main Content Card */}
        <Card 
          elevation={0}
          sx={{ 
            borderRadius: 3,
            border: "1px solid #E0E0E0"
          }}
        >
          {/* Card Header */}
          <Box sx={{ p: 3, borderBottom: "1px solid #E0E0E0" }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, color: "#1A1A1A" }}>
              {activeTab === 0 ? "Pending Residents" : "All Registered Users"}
            </Typography>
            <Typography variant="body2" sx={{ color: "#666" }}>
              {activeTab === 0
                ? "Review, verify and approve resident accounts for app access."
                : "View and manage all registered users in the system."}
            </Typography>
          </Box>

          {/* Search & Actions Bar */}
          <Box sx={{ p: 3, borderBottom: "1px solid #F0F0F0", bgcolor: "#FAFAFA" }}>
            <Stack 
              direction={{ xs: "column", sm: "row" }} 
              spacing={2} 
              alignItems={{ xs: "stretch", sm: "center" }}
            >
              <TextField
                placeholder="Search by name, phone, email or ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                size="small"
                sx={{ 
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white"
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="outlined"
                onClick={handleSelectAll}
                disabled={paginatedUsers.length === 0}
                sx={{ 
                  textTransform: "none",
                  borderColor: "#006D77",
                  color: "#006D77",
                  "&:hover": {
                    borderColor: "#005A63",
                    bgcolor: "rgba(0, 109, 119, 0.04)"
                  }
                }}
              >
                {selectedUsers.length === paginatedUsers.length && paginatedUsers.length > 0
                  ? "Deselect All"
                  : "Select All"}
              </Button>
              {(searchQuery || selectedUsers.length > 0) && (
                <Button
                  variant="text"
                  onClick={() => {
                    setSearchQuery("");
                    setSelectedUsers([]);
                  }}
                  sx={{ 
                    color: "#666",
                    textTransform: "none"
                  }}
                >
                  Clear
                </Button>
              )}
            </Stack>

            {/* Selection Info */}
            {selectedUsers.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Chip
                  label={`${selectedUsers.length} user(s) selected`}
                  size="small"
                  sx={{
                    bgcolor: "#E3F2FD",
                    color: "#1976D2",
                    fontWeight: 600
                  }}
                />
              </Box>
            )}
          </Box>

          {/* Table Header */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "40px 1fr 100px",
                sm: "40px 2fr 1.5fr 1.5fr 1fr 1fr 120px",
              },
              gap: 2,
              px: 3,
              py: 2,
              bgcolor: "#F9FAFB",
              borderBottom: "2px solid #E0E0E0",
            }}
          >
            <Box />
            <Typography variant="body2" sx={{ fontWeight: 700, color: "#424242" }}>Name</Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700, 
                color: "#424242",
                display: { xs: "none", sm: "block" }
              }}
            >
              Phone
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700, 
                color: "#424242",
                display: { xs: "none", sm: "block" }
              }}
            >
              Email
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700, 
                color: "#424242",
                display: { xs: "none", sm: "block" }
              }}
            >
              {activeTab === 0 ? "Registered" : "Role"}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700, 
                color: "#424242",
                display: { xs: "none", sm: "block" }
              }}
            >
              Status
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: "#424242" }}>Actions</Typography>
          </Box>

          {/* User Rows */}
          <Box sx={{ minHeight: 400 }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
                <CircularProgress sx={{ color: "#006D77" }} />
              </Box>
            ) : paginatedUsers.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <Typography variant="h6" sx={{ color: "#999", mb: 1 }}>
                  {searchQuery ? "No users found" : "No users to display"}
                </Typography>
                <Typography variant="body2" sx={{ color: "#BBB" }}>
                  {searchQuery 
                    ? "Try adjusting your search criteria"
                    : activeTab === 0 
                      ? "No pending registrations at this time"
                      : "No users in the system"}
                </Typography>
              </Box>
            ) : (
              <Fade in={!loading}>
                <Box>
                  {paginatedUsers.map((user, index) => (
                    <Box
                      key={user.user_id}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "40px 1fr 100px",
                          sm: "40px 2fr 1.5fr 1.5fr 1fr 1fr 120px",
                        },
                        gap: 2,
                        px: 3,
                        py: 2.5,
                        borderBottom: index < paginatedUsers.length - 1 ? "1px solid #F0F0F0" : "none",
                        alignItems: "center",
                        transition: "all 0.2s",
                        "&:hover": { 
                          backgroundColor: "#F9FAFB",
                          cursor: "pointer"
                        },
                      }}
                    >
                      <Checkbox
                        checked={selectedUsers.includes(user.user_id)}
                        onChange={() => handleSelectUser(user.user_id)}
                        size="small"
                        sx={{
                          color: "#006D77",
                          "&.Mui-checked": {
                            color: "#006D77"
                          }
                        }}
                      />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: "#1A1A1A", mb: 0.25 }}>
                          {user.name}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#999" }}>
                          ID: {user.user_id?.substring(0, 10)}...
                        </Typography>
                      </Box>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: "#424242",
                          display: { xs: "none", sm: "block" }
                        }}
                      >
                        {user.phone}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontSize: "13px",
                          color: "#424242",
                          display: { xs: "none", sm: "block" },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        title={user.email}
                      >
                        {user.email}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontSize: "13px",
                          color: "#666",
                          display: { xs: "none", sm: "block" }
                        }}
                      >
                        {activeTab === 0 ? formatDate(user.registered_at) : user.role || "N/A"}
                      </Typography>
                      <Box sx={{ display: { xs: "none", sm: "block" } }}>
                        {getStatusChip(user)}
                      </Box>
                      <Box sx={{ display: "flex", gap: 0.5, justifyContent: "flex-end" }}>
                        {getActionButtons(user)}
                        <IconButton
                          size="small"
                          onClick={() => handleViewDetails(user)}
                          sx={{ 
                            border: "1px solid #E0E0E0",
                            width: 32,
                            height: 32,
                            color: "#006D77",
                            "&:hover": {
                              bgcolor: "rgba(0, 109, 119, 0.04)",
                              borderColor: "#006D77"
                            }
                          }}
                          title="View Details"
                        >
                          <VisibilityIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteClick(user.user_id, user.name)}
                          sx={{
                            border: "1px solid #FFCDD2",
                            width: 32,
                            height: 32,
                            color: "#C62828",
                            "&:hover": {
                              bgcolor: "#FFEBEE",
                              borderColor: "#C62828"
                            }
                          }}
                          title="Delete User"
                        >
                          <DeleteIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Fade>
            )}
          </Box>

          {/* Pagination */}
          {!loading && filteredUsers.length > 0 && (
            <Box sx={{ borderTop: "1px solid #E0E0E0" }}>
              <TablePagination
                component="div"
                count={filteredUsers.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                sx={{
                  "& .MuiTablePagination-toolbar": {
                    px: 2
                  },
                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                    color: "#666",
                    fontSize: "14px"
                  },
                  "& .MuiTablePagination-select": {
                    color: "#006D77",
                    fontWeight: 600
                  }
                }}
              />
            </Box>
          )}

          {/* Bulk Actions Bar */}
          {selectedUsers.length > 0 && (
            <Box 
              sx={{ 
                p: 2,
                bgcolor: "#F0F9FF",
                borderTop: "1px solid #BFDBFE",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2
              }}
            >
              <Typography variant="body2" sx={{ color: "#1E40AF", fontWeight: 600 }}>
                {selectedUsers.length} user(s) selected
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {activeTab === 0 ? (
                  <>
                    <Button
                      variant="contained"
                      onClick={() => handleActionClick("approve")}
                      disabled={loading}
                      sx={{
                        backgroundColor: "#2E7D32",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": { backgroundColor: "#1B5E20" },
                      }}
                    >
                      Approve Selected
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => handleActionClick("reject")}
                      disabled={loading}
                      sx={{ 
                        borderColor: "#C62828",
                        color: "#C62828",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": {
                          borderColor: "#B71C1C",
                          bgcolor: "#FFEBEE"
                        }
                      }}
                    >
                      Reject Selected
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => handleDeleteClick()}
                      disabled={loading}
                      sx={{
                        borderColor: "#C62828",
                        color: "#C62828",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": {
                          borderColor: "#B71C1C",
                          bgcolor: "#FFEBEE"
                        }
                      }}
                    >
                      Delete Selected
                    </Button>
                  </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => handleActionClick("block")}
                    disabled={loading}
                    sx={{ 
                      borderColor: "#6A1B9A",
                      color: "#6A1B9A",
                      textTransform: "none",
                      fontWeight: 600,
                      "&:hover": {
                        borderColor: "#4A148C",
                        bgcolor: "#F3E5F5"
                      }
                    }}
                  >
                    Block Selected
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => handleDeleteClick()}
                    disabled={loading}
                    sx={{
                      borderColor: "#C62828",
                      color: "#C62828",
                      textTransform: "none",
                      fontWeight: 600,
                      "&:hover": {
                        borderColor: "#B71C1C",
                        bgcolor: "#FFEBEE"
                      }
                    }}
                  >
                    Delete Selected
                  </Button>
                </>
              )}
              </Stack>
            </Box>
          )}
        </Card>

        {/* Action Dialog */}
        <Dialog 
          open={actionDialog.open} 
          onClose={() => !loading && setActionDialog({ open: false, type: "", userIds: [], userNames: [], reason: "" })} 
          maxWidth="sm" 
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3
            }
          }}
        >
          <DialogTitle sx={{ pb: 2, borderBottom: "1px solid #E0E0E0" }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {dialogConfig.title}
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
              {dialogConfig.message}
            </Typography>
            {actionDialog.userNames.length > 0 && (
              <Paper 
                elevation={0}
                sx={{ 
                  mb: 2,
                  p: 2,
                  bgcolor: "#F9FAFB",
                  border: "1px solid #E0E0E0",
                  borderRadius: 2
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: "#1A1A1A" }}>
                  Selected Users:
                </Typography>
                {actionDialog.userNames.map((name, idx) => (
                  <Typography key={idx} variant="body2" sx={{ color: "#666", mb: 0.5 }}>
                    • {name}
                  </Typography>
                ))}
              </Paper>
            )}
            {dialogConfig.requiresReason && (
              <TextField
                multiline
                rows={4}
                fullWidth
                value={actionDialog.reason}
                onChange={(e) => setActionDialog({ ...actionDialog, reason: e.target.value })}
                placeholder="Enter reason (minimum 5 characters)..."
                variant="outlined"
                error={actionDialog.reason.length > 0 && actionDialog.reason.length < 5}
                helperText={
                  actionDialog.reason.length > 0 && actionDialog.reason.length < 5
                    ? "Reason must be at least 5 characters"
                    : ""
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#006D77"
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#006D77"
                    }
                  }
                }}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, borderTop: "1px solid #E0E0E0" }}>
            <Button
              onClick={() => setActionDialog({ open: false, type: "", userIds: [], userNames: [], reason: "" })}
              disabled={loading}
              sx={{ 
                textTransform: "none",
                color: "#666"
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmAction}
              variant="contained"
              disabled={loading || (dialogConfig.requiresReason && actionDialog.reason.trim().length < 5)}
              sx={{ 
                textTransform: "none",
                bgcolor: dialogConfig.color === "success" ? "#2E7D32" : "#C62828",
                "&:hover": {
                  bgcolor: dialogConfig.color === "success" ? "#1B5E20" : "#B71C1C"
                },
                minWidth: 100
              }}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Confirm"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* View Details Dialog */}
        <Dialog 
          open={viewDetailsOpen} 
          onClose={() => setViewDetailsOpen(false)} 
          maxWidth="sm" 
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3
            }
          }}
        >
          <DialogTitle 
            sx={{ 
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 2,
              borderBottom: "1px solid #E0E0E0"
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              User Details
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => setViewDetailsOpen(false)}
              sx={{
                color: "#666",
                "&:hover": {
                  bgcolor: "#F0F0F0"
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {selectedUser && (
              <Box>
                {/* Basic Info */}
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
                    <PersonIcon sx={{ mr: 1.5, color: "#006D77", mt: 0.5 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 0.5 }}>
                        Full Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: "#1A1A1A" }}>
                        {selectedUser.name}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
                    <EmailIcon sx={{ mr: 1.5, color: "#006D77", mt: 0.5 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242", wordBreak: "break-word" }}>
                        {selectedUser.email}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
                    <PhoneIcon sx={{ mr: 1.5, color: "#006D77", mt: 0.5 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 0.5 }}>
                        Phone Number
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#424242" }}>
                        {selectedUser.phone}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Address */}
                {selectedUser.address && (
                  <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                      <HomeIcon sx={{ mr: 1.5, color: "#006D77", mt: 0.5 }} />
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 1 }}>
                          Residential Address
                        </Typography>
                        <Paper 
                          elevation={0}
                          sx={{ 
                            p: 2,
                            bgcolor: "#F9FAFB",
                            border: "1px solid #E0E0E0",
                            borderRadius: 2
                          }}
                        >
                          <Typography variant="body2" sx={{ lineHeight: 1.8, color: "#424242" }}>
                            <strong>Community:</strong> {selectedUser.address.community_name || "-"}<br />
                            <strong>Block:</strong> {selectedUser.address.address_line1 || "-"}<br />
                            <strong>Flat/House:</strong> {selectedUser.address.address_line2 || "-"}<br />
                            {selectedUser.address.landmark && (
                              <>
                                <strong>Landmark:</strong> {selectedUser.address.landmark}<br />
                              </>
                            )}
                            <strong>City:</strong> {selectedUser.address.city || "-"}<br />
                            <strong>State:</strong> {selectedUser.address.state || "-"}<br />
                            <strong>Pincode:</strong> {selectedUser.address.pincode || "-"}
                          </Typography>
                          {selectedUser.address.address_type && (
                            <Chip 
                              label={selectedUser.address.address_type} 
                              size="small" 
                              sx={{ 
                                mt: 1.5,
                                textTransform: "capitalize",
                                bgcolor: "#E3F2FD",
                                color: "#1976D2",
                                fontWeight: 600
                              }}
                            />
                          )}
                        </Paper>
                      </Box>
                    </Box>
                  </Box>
                )}

                <Divider sx={{ my: 3 }} />

                {/* Status Info */}
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="body2" sx={{ color: "#666", fontWeight: 600 }}>
                      Role:
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#1A1A1A" }}>
                      {selectedUser.role || "N/A"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="body2" sx={{ color: "#666", fontWeight: 600 }}>
                      Status:
                    </Typography>
                    {getStatusChip(selectedUser)}
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="body2" sx={{ color: "#666", fontWeight: 600 }}>
                      Registered:
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#1A1A1A" }}>
                      {formatDate(selectedUser.registered_at)}
                    </Typography>
                  </Box>

                  {selectedUser.approved_at && (
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                      <Typography variant="body2" sx={{ color: "#666", fontWeight: 600 }}>
                        Approved/Rejected:
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#1A1A1A" }}>
                        {formatDate(selectedUser.approved_at)}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Rejection Reason */}
                {selectedUser.rejection_reason && (
                  <Paper 
                    elevation={0}
                    sx={{ 
                      mt: 3,
                      p: 2,
                      bgcolor: "#FFEBEE",
                      border: "1px solid #FFCDD2",
                      borderRadius: 2
                    }}
                  >
                    <Typography variant="caption" sx={{ color: "#C62828", fontWeight: 700, display: "block", mb: 0.5 }}>
                      Rejection/Block Reason:
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#C62828" }}>
                      {selectedUser.rejection_reason}
                    </Typography>
                  </Paper>
                )}

                {/* Family Members */}
                {selectedUser.family_members && selectedUser.family_members.length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 1.5, color: "#1A1A1A" }}>
                      Family Members:
                    </Typography>
                    <Paper 
                      elevation={0}
                      sx={{ 
                        p: 2,
                        bgcolor: "#F9FAFB",
                        border: "1px solid #E0E0E0",
                        borderRadius: 2
                      }}
                    >
                      {selectedUser.family_members.map((member, idx) => (
                        <Typography key={idx} variant="body2" sx={{ mb: 1, color: "#424242" }}>
                          • {member.name} ({member.relation}) - {member.age} years, {member.gender}
                        </Typography>
                      ))}
                    </Paper>
                  </Box>
                )}

                {/* Emergency Contacts */}
                {selectedUser.emergency_contacts && selectedUser.emergency_contacts.length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 1.5, color: "#1A1A1A" }}>
                      Emergency Contacts:
                    </Typography>
                    <Paper 
                      elevation={0}
                      sx={{ 
                        p: 2,
                        bgcolor: "#F9FAFB",
                        border: "1px solid #E0E0E0",
                        borderRadius: 2
                      }}
                    >
                      {selectedUser.emergency_contacts.map((contact, idx) => (
                        <Typography key={idx} variant="body2" sx={{ mb: 0.5, color: "#424242" }}>
                          • {contact}
                        </Typography>
                      ))}
                    </Paper>
                  </Box>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, borderTop: "1px solid #E0E0E0" }}>
            <Button 
              onClick={() => setViewDetailsOpen(false)}
              variant="contained"
              sx={{ 
                textTransform: "none",
                bgcolor: "#006D77",
                "&:hover": {
                  bgcolor: "#005A63"
                }
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>


        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteDialog.open}
          onClose={() => !loading && setDeleteDialog({ open: false, userIds: [], userNames: [] })}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle sx={{ pb: 2, borderBottom: "1px solid #E0E0E0" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box sx={{
                width: 40, height: 40, borderRadius: "50%",
                bgcolor: "#FFEBEE", display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                <DeleteIcon sx={{ color: "#C62828", fontSize: 20 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#C62828" }}>
                Delete User{deleteDialog.userIds.length > 1 ? "s" : ""}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Paper elevation={0} sx={{ p: 2, bgcolor: "#FFF8F8", border: "1px solid #FFCDD2", borderRadius: 2, mb: 2 }}>
              <Typography variant="body2" sx={{ color: "#C62828", fontWeight: 600, mb: 0.5 }}>
                 This action is permanent and cannot be undone.
              </Typography>
              <Typography variant="body2" sx={{ color: "#C62828" }}>
                The user(s) will be permanently removed from MongoDB, Redis and Firebase.
              </Typography>
            </Paper>
            <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
              You are about to delete {deleteDialog.userIds.length} user(s):
            </Typography>
            <Paper elevation={0} sx={{ p: 2, bgcolor: "#F9FAFB", border: "1px solid #E0E0E0", borderRadius: 2 }}>
              {deleteDialog.userNames.map((name, idx) => (
                <Typography key={idx} variant="body2" sx={{ color: "#424242", mb: 0.5 }}>
                  • {name}
                </Typography>
              ))}
            </Paper>
          </DialogContent>
          <DialogActions sx={{ p: 2, borderTop: "1px solid #E0E0E0" }}>
            <Button
              onClick={() => setDeleteDialog({ open: false, userIds: [], userNames: [] })}
              disabled={loading}
              sx={{ textTransform: "none", color: "#666" }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              variant="contained"
              disabled={loading}
              sx={{
                textTransform: "none",
                bgcolor: "#C62828",
                "&:hover": { bgcolor: "#B71C1C" },
                minWidth: 130
              }}
            >
              {loading ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                `Delete Permanently`
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Custom Notification Dialog */}
        <CustomDialog
          open={notificationDialog.open}
          onClose={() => setNotificationDialog({ ...notificationDialog, open: false })}
          title={notificationDialog.title}
          message={notificationDialog.message}
          type={notificationDialog.type}
          buttonText="OK"
        />
      </Container>
    </Box>
  );
};

export default AdminPendingUsers;